export default theme => ({
  currency: {
    color: theme.palette.text.secondary
  },
  tableCell: {
    display: "flex",
    justifyContent: "space-between"
  }
});
